// extracted by mini-css-extract-plugin
export default {"form":"Login_form__rQ1wj","wrapper":"Login_wrapper__b70+O","actions":"Login_actions__A1Swk"};